import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

import Header from "../components/Header";
import MainBanner2 from "../components/MainBanner2";
import Home2OurBlog from "../components/Home2OurBlog";
import OrderStore from "../components/OrderStore";
import OurEvent from "../components/OurEvent";
import Home2Testimonial from "../components/Home2Testimonial";
import ContactSection from "../components/Contact";
import Footer2 from "../components/Footer2";
import MichelinAward from "../components/MichelinGuide";

const Home2 = ({ restaurant }) => {
  const navigate = useNavigate();
  const [showWelcome, setShowWelcome] = useState(false);



  return (
    <div className="page-content bg-white">
      <Header />
      <MainBanner2 />
      <MichelinAward />
      <Home2OurBlog />
      <OrderStore />
      <OurEvent />
      <Home2Testimonial />
      <ContactSection />
      <Footer2 />

      {/* Welcome Modal */}
      <Modal show={showWelcome} onHide={() => setShowWelcome(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Welcome to Petals of a Peony</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          🎉 You can now place your order at <strong>Little Petals</strong> directly on this website.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              setShowWelcome(false);
              navigate("/online-order");
            }}
          >
            Start Ordering
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Home2;
